import { createContext } from "react";

const CoverageTabContext = createContext({});

export default CoverageTabContext;
